import React from "react"

const defaultState = ''

export const Context = React.createContext(defaultState)